import React, {useEffect} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { FormControlLabel, Radio } from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import ListSubheader from '@material-ui/core/ListSubheader';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from "@material-ui/core/MenuItem";
import Box from "@material-ui/core/Box";
import InputAdornment from '@material-ui/core/InputAdornment';
// Form related
import { Field } from 'formik';
import {CheckboxWithLabel, RadioGroup, Select} from 'formik-material-ui';
import { DatePicker } from 'formik-material-ui-pickers';
import MaterialTable from "material-table";
import Numeral from 'numeral';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import AddressInput from "../../../components/AddressInput/AddressInput";

import fieldData from '../FormModel/fieldData.js';
import multipleNSAFormInitialValue from "../FormModel/multipleNSAFormInitialValue";
import connectionFormStyle from "../../../assets/jss/material-dashboard-react/views/connectionFormStyle";

const useStyles = makeStyles(connectionFormStyle);

export default function ServiceDetails(props) {
    const {formField, values, setFieldValue, setServiceData} = props;
    const state = fieldData.state;
    const classes = useStyles();
    const [willPort, setWillPort] = React.useState(false);
    const [portPrepaid, setPortPrepaid] = React.useState(false);
    const [portPostpaid, setPortPostpaid] = React.useState(false);
    const [tblRows, setTblRows] = React.useState([]);
    const [tblHeader, setTblHeader] = React.useState([]);
    let default_delivery_street = values[formField.current_trading_address.fields.street.name];
    let default_delivery_state = values[formField.current_trading_address.fields.state.name];
    let default_delivery_postcode = values[formField.current_trading_address.fields.postcode.name];

    const setDefaultDeliveryAddress = () => {
        setFieldValue(formField.delivery_address.fields.street.name, default_delivery_street);
        setFieldValue(formField.delivery_address.fields.state.name, default_delivery_state);
        setFieldValue(formField.delivery_address.fields.postcode.name, default_delivery_postcode);
    };

    useEffect(() => {
        setDefaultDeliveryAddress();

        // Set table headers
        let date_elements = [formField.msn_dob.name, formField.target_port_date.name];
        let money_elements = [formField.mpp_monthly_payment.name, formField.mpp_total_amount.name];
        let header_checker = [];

        for( let key in multipleNSAFormInitialValue ) {
            if( !multipleNSAFormInitialValue.hasOwnProperty(key) ) {
                continue;
            }

            let new_row = {
                title: "",
                field: key
            };

            if( key.indexOf('delivery_address_') !== -1 ) {
                let key_test = header_checker.filter(header => header.field === "delivery_address");

                if( key_test.length === 0 ) {
                    new_row = {
                        title: "Delivery Address",
                        field: "delivery_address",
                        render: rowData => rowData.delivery_address_street + ", " + rowData.delivery_address_state + ", " + rowData.delivery_address_postcode
                    };
                }
                else {
                    continue;
                }
            }
            else {
                new_row.title = formField[key].label;
            }

            if( date_elements.includes(key) ) {
                new_row.render = rowData => {
                    return (typeof rowData[key] === 'object') ? rowData[key].format("DD/MM/YYYY") : rowData[key];
                }
            }
            if( money_elements.includes(key) ) {
                new_row.render = rowData => {
                    return Numeral(rowData[key]).format('$ 0,0[.]00');
                }
            }

            header_checker.push(new_row);

            setTblHeader((old) => {
                let new_arr = old.slice(0);
                new_arr.push(new_row);
                return new_arr;
            });
        }
    }, []);

    useEffect(() => {
        setServiceData(tblRows);
    }, [tblRows]);


    const onClick = (event) => {
        if( event.target.name === formField.will_port_current_no.name ) {
            if( event.target.value === "yes" ) {
                setWillPort(true);
            } else {
                setWillPort(false);
            }
        }
        else if( event.target.name === formField.current_prepaid.name ) {
            setPortPrepaid(wasOpened => !wasOpened);
        }
        else if( event.target.name === formField.current_postpaid.name ) {
            setPortPostpaid(wasOpened => !wasOpened);
        }
    };

    const calculateMppMonthly = (event) => {
        let total = values.mpp_total_amount;
        let term = values.mpp_term;

        if( total > 0 && term > 0 ) {
            setFieldValue(formField.mpp_monthly_payment.name, (total / term));
        }
    };

    const handleReset = () => {
        for( let key in multipleNSAFormInitialValue ) {
            if( !multipleNSAFormInitialValue.hasOwnProperty(key) ) {
                continue;
            }

            setFieldValue(key, multipleNSAFormInitialValue[key]);
        }

        setWillPort(false);
        setPortPostpaid(false);
        setPortPrepaid(false);
        setDefaultDeliveryAddress();
    };

    const dependentFields = [
        {state: willPort, dependent: [formField.current_prepaid.name, formField.current_postpaid.name, formField.target_port_date.name]},
        {state: portPrepaid, dependent: [formField.msn_dob.name]}
    ];
    const handleAddMore = () => {
        let new_row = {};

        for( let key in multipleNSAFormInitialValue ) {
            if (!multipleNSAFormInitialValue.hasOwnProperty(key)) {
                continue;
            }

            let value = values[key];

            if ((typeof formField[key] !== 'undefined')) {
                if (formField[key].type === "boolean") {
                    value = values[key] ? "Yes" : "No";
                }
                else if (formField[key].type === "yes_no") {
                    value = value === 'yes' ? "Yes" : "No";
                }
            }

            let is_dependant = dependentFields.filter(field => field.dependent.includes(key));

            if( is_dependant.length > 0 && !is_dependant[0].state ) {
                value = "";
            }

            new_row[key] = value;
        }

        setTblRows((old) => {
            let new_arr = old.slice(0);
            new_arr.push(new_row);
            return new_arr;
        });

        handleReset();
    };

    return (
        <div>
            <GridContainer>
                <GridItem xs={12}>
                    <GridContainer>
                        <GridItem xs={12}>
                            <h4 className={classes.sectionHeader}>Plan, SIM & Service Details</h4>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                            <FormControl className={classes.fullWidthSelect}>
                                <InputLabel htmlFor={formField.new_connection_type.name} className={classes.labelComponent}>
                                    {formField.new_connection_type.label}
                                </InputLabel>
                                <Field
                                    component={Select}
                                    label={formField.new_connection_type.label}
                                    name={formField.new_connection_type.name}
                                    id={formField.new_connection_type.name}
                                    inputProps={{
                                        name: formField.new_connection_type.name,
                                        id: formField.new_connection_type.name
                                    }}
                                    className={classes.underline}
                                >
                                    ({
                                        fieldData.new_connection_type.map((prop, key) => <MenuItem key={key} value={prop}>{prop}</MenuItem>)
                                    })
                                </Field>
                            </FormControl>
                            <Field
                                component={CustomInput}
                                labelText={formField.customer_username.label}
                                name={formField.customer_username.name}
                                id={formField.customer_username.name}
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                            <Field
                                component={CustomInput}
                                labelText={formField.pin_no.label}
                                name={formField.pin_no.name}
                                id={formField.pin_no.name}
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                            <FormControl className={classes.fullWidthSelect}>
                                <InputLabel htmlFor={formField.sim_type.name} className={classes.labelComponent}>
                                    {formField.sim_type.label}
                                </InputLabel>
                                <Field
                                    component={Select}
                                    label={formField.sim_type.label}
                                    name={formField.sim_type.name}
                                    id={formField.sim_type.name}
                                    inputProps={{
                                        name: formField.sim_type.name,
                                        id: formField.sim_type.name
                                    }}
                                    className={classes.underline}
                                >
                                ({
                                    fieldData.sim_type.map((prop, key) => <MenuItem key={key} value={prop}>{prop}</MenuItem>)
                                })
                                </Field>
                            </FormControl>
                            <Field
                                component={CustomInput}
                                labelText={formField.sim_no.label}
                                name={formField.sim_no.name}
                                id={formField.sim_no.name}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                helperText="Not required for deferred channels."
                            />
                            <Field
                                component={CustomInput}
                                labelText={formField.imei_no.label}
                                name={formField.imei_no.name}
                                id={formField.imei_no.name}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                helperText="Not required for deferred channels."
                            />
                            <Field
                                component={CustomInput}
                                labelText={formField.assigned_mobile_no.label}
                                name={formField.assigned_mobile_no.name}
                                id={formField.assigned_mobile_no.name}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                helperText={<React.Fragment>Always enter the mobile number as '614xxxxxxxx'<br/>Type 'NEW' to have a new Vodafone number connected if no port/transfer is taking place</React.Fragment>}
                            />
                            <FormControl component="fieldset" className={classes.formControl + " " + classes.itemSpacer}>
                                <FormLabel component="legend">{formField.will_port_current_no.label}</FormLabel>
                                <Field component={RadioGroup} name={formField.will_port_current_no.name} className={classes.formGroupHorizontal} onClick={onClick}>
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio />}
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio />}
                                        label="No"
                                    />
                                </Field>
                            </FormControl>
                            { willPort ?
                                <React.Fragment>
                                    <FormGroup className={classes.formGroupHorizontal + " " + classes.itemSpacer}>
                                        <Field
                                            component={CheckboxWithLabel}
                                            name={formField.current_prepaid.name}
                                            id={formField.current_prepaid.name}
                                            type="checkbox"
                                            onClick={onClick}
                                            Label={{ label: formField.current_prepaid.label }}
                                        />
                                        <Field
                                            component={CheckboxWithLabel}
                                            name={formField.current_postpaid.name}
                                            id={formField.current_postpaid.name}
                                            type="checkbox"
                                            onClick={onClick}
                                            Label={{ label: formField.current_postpaid.label }}
                                        />
                                    </FormGroup>
                                    { portPostpaid ?
                                        <Field
                                            component={CustomInput}
                                            labelText={formField.current_carrier_account_number.label}
                                            name={formField.current_carrier_account_number.name}
                                            id={formField.current_carrier_account_number.name}
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                        />
                                    : null }
                                    { portPrepaid ?
                                        <Field
                                            component={DatePicker}
                                            format="DD/MM/yyyy"
                                            name={formField.msn_dob.name}
                                            id={formField.msn_dob.name}
                                            label={formField.msn_dob.label}
                                            disableFuture={true}
                                            className={classes.itemSpacer + " " + classes.underline}
                                        />
                                    : null }
                                    <Field
                                        component={DatePicker}
                                        format="DD/MM/yyyy"
                                        name={formField.target_port_date.name}
                                        id={formField.target_port_date.name}
                                        label={formField.target_port_date.label}
                                        disablePast={true}
                                        className={classes.itemSpacer + " " + classes.underline}
                                        style={{
                                            display: "block"
                                        }}
                                    />
                                </React.Fragment>
                            : null }
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                            <FormControl className={classes.fullWidthSelect}>
                                <InputLabel htmlFor={formField.plan_name.name} className={classes.labelComponent}>
                                    {formField.plan_name.label}
                                </InputLabel>
                                <Field
                                    component={Select}
                                    label={formField.plan_name.label}
                                    name={formField.plan_name.name}
                                    id={formField.plan_name.name}
                                    inputProps={{
                                        name: formField.plan_name.name,
                                        id: formField.plan_name.name
                                    }}
                                    className={classes.underline}
                                >
                                    ({
                                        fieldData.plan_name.map((prop, key) => {
                                            let options = [];
                                            options.push(<ListSubheader key={prop.name}>{prop.name}</ListSubheader>);
                                            {prop.plans.map((plan_prop) => {
                                                return options.push(<MenuItem key={plan_prop} value={plan_prop}>{plan_prop}</MenuItem>);
                                            })}

                                            return options;
                                        })
                                    })
                                </Field>
                            </FormControl>
                            <FormControl className={classes.fullWidthSelect}>
                                <InputLabel htmlFor={formField.plan_term.name} className={classes.labelComponent}>
                                    {formField.plan_term.label}
                                </InputLabel>
                                <Field
                                    component={Select}
                                    label={formField.plan_term.label}
                                    name={formField.plan_term.name}
                                    id={formField.plan_term.name}
                                    inputProps={{
                                        name: formField.plan_term.name,
                                        id: formField.plan_term.name
                                    }}
                                    className={classes.underline}
                                >
                                    ({
                                        fieldData.plan_term.map((prop, key) => <MenuItem key={key} value={prop}>{prop}</MenuItem>)
                                    })
                                </Field>
                            </FormControl>
                            <Field
                                component={CustomInput}
                                labelText={formField.device.label}
                                name={formField.device.name}
                                id={formField.device.name}
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                            <GridContainer>
                                <GridItem xs={6} sm={6} md={4}>
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.mpp_total_amount.label}
                                        name={formField.mpp_total_amount.name}
                                        id={formField.mpp_total_amount.name}
                                        formControlProps={{
                                            fullWidth: false
                                        }}
                                        inputProps={{
                                            type: "number",
                                            startAdornment:<InputAdornment position="start">$</InputAdornment>
                                        }}
                                        onBlur={calculateMppMonthly}
                                    />
                                </GridItem>
                                <GridItem xs={6} sm={6} md={4}>
                                    <FormControl className={classes.fullWidthSelect} style={{paddingBottom: "10px", margin: "27px 0 0 0"}}>
                                        <InputLabel htmlFor={formField.mpp_term.name} className={classes.labelComponent}>
                                            {formField.mpp_term.label}
                                        </InputLabel>
                                        <Field
                                            component={Select}
                                            label={formField.mpp_term.label}
                                            name={formField.mpp_term.name}
                                            id={formField.mpp_term.name}
                                            inputProps={{
                                                name: formField.mpp_term.name,
                                                id: formField.mpp_term.name,
                                                onBlur: calculateMppMonthly
                                            }}
                                            className={classes.underline}
                                        >
                                            ({
                                            fieldData.mpp_term.map((prop, key) => <MenuItem key={key} value={prop}>{prop}</MenuItem>)
                                        })
                                        </Field>
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={6} sm={6} md={4}>
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.mpp_monthly_payment.label}
                                        name={formField.mpp_monthly_payment.name}
                                        id={formField.mpp_monthly_payment.name}
                                        formControlProps={{
                                            fullWidth: false
                                        }}
                                        inputProps={{
                                            type: "number",
                                            readOnly: true,
                                            startAdornment:<InputAdornment position="start">$</InputAdornment>
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <FormControl component="fieldset" className={classes.formControl + " " + classes.itemSpacer}>
                                <FormLabel component="legend">{formField.insurance.label}</FormLabel>
                                <Field component={RadioGroup} name={formField.insurance.name} className={classes.formGroupHorizontal}>
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio />}
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio />}
                                        label="No"
                                    />
                                </Field>
                            </FormControl>
                            <AddressInput formField={formField.delivery_address} classes={classes} states={state} />
                            <Field
                                component={CustomInput}
                                labelText={formField.special_instruction.label}
                                name={formField.special_instruction.name}
                                id={formField.special_instruction.name}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    multiline: true,
                                    rows: 2
                                }}
                            />
                        </GridItem>
                        <GridItem xs={12}>
                            <Box style={{margin: "15px 0"}}>
                                <Button onClick={handleAddMore} className={classes.button} color="primary" style={{marginRight: "15px"}}>
                                    Add More
                                </Button>
                                <Button onClick={handleReset} className={classes.button}>
                                    Reset
                                </Button>
                            </Box>
                        </GridItem>
                        <GridItem xs={12}>
                            <Box style={{marginTop: "15px"}}>
                                <MaterialTable
                                    columns={tblHeader}
                                    data={tblRows}
                                    actions={[
                                        {
                                            icon: 'edit',
                                            tooltip: 'Edit Item',
                                            onClick: (event, rowData) => alert("Values will be populated in the form when this button is clicked.")
                                        }
                                    ]}
                                    options={{
                                        showTitle: false,
                                        search: false,
                                        toolbar: false,
                                        pageSize: 5,
                                        pageSizeOptions: [5, 15, 25]
                                    }}
                                />
                            </Box>
                        </GridItem>
                    </GridContainer>
                </GridItem>
            </GridContainer>
        </div>
    );
}
